export const DOCUMENT_TYPE_COLLECTION_GUIDEBOOK = 'collection-guidebook';
